/* import __COLOCATED_TEMPLATE__ from './membership-plan-section.hbs'; */
import Component from '@glimmer/component';

export default class MembershipPlanSectionComponent extends Component {}
